import { SideModal } from '@design-system/components/modal/sideModal';
import { extrasVM } from '../Extras.page';
import { LinkForm } from './link.form';
import { formWrapper } from '@client/new/pages/challenges/view/Challenges.view.css';

export const LinkView = () => {
  const vm = extrasVM.useValue();
  const linkVM = vm.linkVM;

  const isOpen = linkVM.mode === 'create' || linkVM.mode === 'edit';

  return (
    <SideModal
      isOpen={isOpen}
      onClose={() => linkVM.dispatch('Cancel')}
      noSpacing
      testId="link-form-modal"
    >
      <div key={linkVM.content.id} className={formWrapper}>
        <LinkForm
          linkVM={linkVM}
          onSubmit={() => {
            if (linkVM.mode === 'create') {
              // For create mode, validate form and create through model
              linkVM.handleCreate();
            }
            // For edit mode, auto-save handles it via onBlur
          }}
        />
      </div>
    </SideModal>
  );
};
